import React from 'react';
import { Modal } from 'react-bootstrap';

interface VideoPreviewModalProps {
  show: boolean;
  onHide: () => void;
  videoId: string;
  title?: string;
}

export const VideoPreviewModal: React.FC<VideoPreviewModalProps> = ({
  show,
  onHide,
  videoId,
  title = "Preview do Vídeo",
}) => {

  const renderVideoContent = () => (
    <iframe
      src={`https://customer-tv6a4xnmx32jrk21.cloudflarestream.com/${videoId}/iframe`}
      title={title}
      style={{
        width: '100%',
        height: '70vh',
        border: 'none',
        borderRadius: '12px'
      }}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
      allowFullScreen
    />
  );

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {renderVideoContent()}
      </Modal.Body>
    </Modal>
  );
};
